import { TheNav, Fotter } from './Home'

const LegalMentions = () => {
  return (
    <section className="unid:mx-[100px] mx-[50px] undi:px-32 px-16  py-8 bg-white text-gray-800 undi:mt-14 mt-20">
      <h1 className="text-3xl font-bold mb-8 text-center text-black font-times">Mentions Légales</h1>
      
      <div className="space-y-8">
        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 text-[#D72427] font-times">ARTICLE 1 - Informations légales</h2>
          <div className="space-y-4">
            <div>
              <p className="font-bold text-gray-900">Propriété</p>
              <p>Le site francilienneformation.fr appartient à La Francilienne de la Formation, située au 15 Rue de l'Université, 93160 Noisy-le-Grand.</p>
            </div>
            <div>
              <p className="font-bold text-gray-900">La Francilienne de la Formation</p>
              <p>15 rue de l'Université, 93160 Noisy-le-Grand</p>
              <p>
                Email : <a href="mailto:Direction.francilienne.formation@gmail.com" className="text-[#D72427] hover:underline">
                  Direction.francilienne.formation@gmail.com
                </a>
              </p>
              <p>Téléphone : 09 52 30 99 38</p>
              <p>Siret : 89462489900015</p>
            </div>
          </div>
        </article>

        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 text-[#D72427] font-times">ARTICLE 2 : Hébergeur</h2>
          <div className="space-y-2">
            <p>AlwaysData</p>
            <p>91 Rue du Faubourg Saint-Honoré, 75008 Paris</p>
            <p>
              Email : <a href="mailto:contact@alwaysdata.com" className="text-[#D72427] hover:underline">
                contact@alwaysdata.com
              </a>
            </p>
          </div>
        </article>

        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 text-[#D72427] font-times">ARTICLE 3 : Conditions générales d'utilisation</h2>
          <p>La navigation sur le site implique l'acceptation des CGU et des CGV. Les informations peuvent être mises à jour à tout moment.</p>
        </article>

        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 text-[#D72427] font-times">ARTICLE 4 : Gestion des données personnelles</h2>
          <p>Les données collectées sont utilisées exclusivement pour répondre aux demandes des utilisateurs. Conformément à la loi Informatique et Libertés, toute réclamation doit être adressée par email avec une demande écrite et un justificatif d'identité.</p>
        </article>

        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 text-[#D72427] font-times">ARTICLE 5 : Propriété intellectuelle</h2>
          <p>Le contenu du site est la propriété exclusive de La Francilienne de la Formation. Toute reproduction ou utilisation non autorisée est interdite.</p>
        </article>

        <article className="pb-6">
          <h2 className="text-2xl font-semibold mb-4 text-[#D72427] font-times">ARTICLE 6 : Liens hypertextes</h2>
          <p>La création de liens vers ce site nécessite une autorisation préalable.</p>
        </article>
      </div>

      <footer className="mt-8 pt-6 border-t border-gray-200 text-sm text-gray-600">
        <p>Dernière mise à jour : 19/02/2025</p>
        <p>Gérant : Nadir SAIDI</p>
      </footer>
    </section>
  );
};

export const MentionLegal = () =>{
    return(
        <>
            <TheNav/>
            <LegalMentions/>
            <Fotter/>
        </>
    );
}